export const Divider = () => (
  <li className="border-0 border-b border-solid border-navy_light list-none my-4" />
);
